/* tslint:disable */
/* eslint-disable */
import * as runtime from '../runtime';
import { CreateUploadUrlResponseFromJSON, GetAssetResponseFromJSON, } from '../models';
/**
 *
 */
export class AssetAdminV1Api extends runtime.BaseAPI {
    /**
     * 업로드 할 Pre-signed URL을 생성한다.  주어진 URL로 Asset을 업로드 하면 된다.
     * 업로드 할 Pre-signed URL을 생성한다.
     */
    async createUploadUrlRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/admin/asset/v1/asset/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUploadUrlResponseFromJSON(jsonValue));
    }
    /**
     * 업로드 할 Pre-signed URL을 생성한다.  주어진 URL로 Asset을 업로드 하면 된다.
     * 업로드 할 Pre-signed URL을 생성한다.
     */
    async createUploadUrl(requestParameters, initOverrides) {
        const response = await this.createUploadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Asset 정보를 가져온다.
     * Asset 정보를 가져온다.
     */
    async getAssetRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getAsset.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/admin/asset/v1/asset/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetResponseFromJSON(jsonValue));
    }
    /**
     * Asset 정보를 가져온다.
     * Asset 정보를 가져온다.
     */
    async getAsset(requestParameters, initOverrides) {
        const response = await this.getAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
